import { api } from "./api";

export interface AttemptOption { id: string; text: string; }
export interface AttemptQuestion {
  attemptQuestionId: string;
  orderIndex: number;
  text: string;
  options: AttemptOption[];
  selectedOptionId: string | null;
}

export interface ProctorClientSettings {
  cameraEnabled: boolean;
  cameraIntervalMinutes: number;
  cameraIntervalSeconds: number;
  fullscreenEnforce: boolean;
  tabSwitchDetect: boolean;
  dualScreenBlock: boolean;
  copyPasteDisable: boolean;
  heartbeatSeconds: number;
}

export interface AttemptView {
  attemptId: string;
  state: string;
  endsAt: string;
  questions: AttemptQuestion[];
  proctor: ProctorClientSettings;
}

export interface Heartbeat {
  serverTime: string;
  endsAt: string;
  secondsRemaining: number;
}

export interface SubmitResult {
  attemptId: string;
  state: string;
  result: {
    positiveTotal: number;
    negativeTotal: number;
    penaltyTotal: number;
    finalScore: number;
    passFail: string | null;
    questionsAttempted: number;
    correct: number;
    wrong: number;
    skipped: number;
  } | null;
  completionMessage: string;
}

export const attemptApi = {
  start: (attemptId: string) =>
    api.post<AttemptView>(`/attempts/${attemptId}/start`).then((r) => r.data),
  get: (attemptId: string) =>
    api.get<AttemptView>(`/attempts/${attemptId}`).then((r) => r.data),
  select: (attemptId: string, attemptQuestionId: string, selectedOptionId: string | null) =>
    api.patch(`/attempts/${attemptId}/answers/${attemptQuestionId}`, { selectedOptionId }),
  heartbeat: (attemptId: string) =>
    api.post<Heartbeat>(`/attempts/${attemptId}/heartbeat`).then((r) => r.data),
  submit: (attemptId: string) =>
    api.post<SubmitResult>(`/attempts/${attemptId}/submit`).then((r) => r.data),
};
